<app-header [enableBack]="true">
  <div title>{{ 'dashboard.pricestatus.title' | translate }}</div>
</app-header>
<div class="p-6">
  <app-table
    [config]="priceStatusTableConfig"
    [data]="tableData">
  </app-table>
</div>
